<template>
  <yxt-drawer
    :title="title"
    :size="size"
    :visible.sync="visible"
    :direction="direction"
    :before-close="close"
  >
    <div class="yxt-supplier-selector-wrap">
      <yxt-row class="yxt-supplier-selector-container" type="flex">
        <yxt-input
          :placeholder="
            $t('pc_biz_o2o_lbl_select_supplier_name' /* 请输入供应商名称搜索 */)
          "
          v-model="selector.keywords"
          class="search-input"
          :disabled="isDisabled"
          clearable
          @clear="search()"
          @keyup.enter.native="search()"
          style="width: 300px"
        >
          <i
            slot="suffix"
            class="yxt-input__icon yxt-icon-search"
            style="cursor: pointer"
            @click="search()"
          ></i>
        </yxt-input>
      </yxt-row>
      <yxt-row class="mt20">
        <yxt-table
          @radio-change="currentChange"
          ref="singleTable"
          radio-row-by-key="radioKey"
          :data="tableData"
          style="width: 100%"
        >
          <yxt-table-column type="radio" width="32"> </yxt-table-column>
          <yxt-table-column
            prop="supplierName"
            :label="$t('pc_biz_o2o_lbl_supplier_name' /* 供应商名称 */)"
          >
          </yxt-table-column>
        </yxt-table>
        <yxt-pagination
          class="pull-right mt20"
          :page-size="limit"
          :total="count"
          :current-page="current"
          @current-change="handelCurrentChange"
          layout="total, prev, pager, next"
          :page-count="totalPage"
        ></yxt-pagination>
      </yxt-row>
    </div>
    <div slot="footer">
      <yxt-button plain @click="close()">{{
        $t('pc_biz_labelling_cancel')
      }}</yxt-button>
      <yxt-button type="primary" @click="submit()">{{
        $t('pc_biz_labelling_confirm')
      }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import { getModuleList } from './service';
export default {
  name: 'YxtbizSupplierSelector',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    filterKey: {
      type: String,
      default: 'id'
    },
    size: {
      type: String,
      default: '600px'
    },
    title: {
      type: String,
      default: '选择供应商'
    }
  },
  data() {
    return {
      selector: { keywords: '' },
      limit: 10,
      current: 1,
      direction: 'rtl',
      tableData: [],
      currentRow: null,
      totalPage: 0,
      count: 0,
      offset: 0
    };
  },
  watch: {
    visible() {
      this.$nextTick(() => {
        this.toggleSelection(
          this.tableData.filter(
            item => item.keyNo === this.value[this.filterKey]
          )
        );
      });
    }
  },
  created() {
    this.getModuleList(this.current - 1);
  },
  methods: {
    search() {
      this.offset = 0;
      this.getModuleList();
    },
    submit() {
      this.$emit('select', { ...this.currentRow });
    },
    close() {
      this.$emit('close');
    },
    currentChange(row) {
      console.log(row);
      this.currentRow = row;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.singleTable.toggleRowCurrentRadio(row);
        });
      } else {
        this.$refs.singleTable.clearCurrentRadio();
      }
    },
    handelCurrentChange(val) {
      this.offset = (val - 1) * 10;
    },
    getModuleList() {
      getModuleList(this.offset, this.limit, this.selector)
        .then(res => {
          console.log(res);
          const { code, data } = res;
          if (code === '0') {
            this.tableData = data.datas;
            this.totalPage = data.paging.totalPages;
            this.count = data.paging.totalCount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
